import React from 'react';
import { Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { darkGrey, transparentWhite, white } from '../../../app/theme';

interface Props {
  isOpen: boolean;
  handleModalOpen: (isOpen: boolean) => void;
}

const useStyles = makeStyles(() => ({
  modalContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBackground: {
    width: '50%',
    backgroundColor: transparentWhite,
    padding: 24,
  },
  modal: {
    padding: '2em',
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: white,
    '& a': {
      color: 'inherit',
    },
  },
  closeButton: {
    position: 'absolute',
    top: '0.25em',
    right: '0.25em',
  },
  text: {
    color: darkGrey,
    fontSize: 20,
  },
}));

const ContactSpecialistModal = ({ isOpen, handleModalOpen }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <Modal open={isOpen} onClose={() => handleModalOpen(false)}>
      <div className={classes.modalContainer}>
        <div className={classes.modalBackground}>
          <div className={classes.modal}>
            <IconButton aria-label="close" className={classes.closeButton} onClick={() => handleModalOpen(false)}>
              <CloseIcon />
            </IconButton>
            <p className={classes.text}>
              Please email
              <a href="mailto:training@blueearthdxmedicalaffairshub.com">
                <strong> training@blueearthdxmedicalaffairshub.com </strong>
              </a>
              to contact a Blue Earth Diagnostics Imaging Specialist regarding your question, comment, or concern. You
              will receive a response within 1-2 business days.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContactSpecialistModal;
